













import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { RenderPostModel } from "@/services/render/types";
import { RssItemProperties, RssCSS } from "@/services/posts/postTypes/rss";
import { setNextItem } from "../types";

@Component
export default class RssRender extends Vue {
    @Prop() private item!: RenderPostModel;
    @Prop() private itemStyle!: Style; // it's used only in style form preview
    @Prop() private active!: number;

    // watcher
    setNextItemTimer = 0;
    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0) {
            clearTimeout(this.setNextItemTimer);
            this.setNextItemTimer = setTimeout(this.setNextItem, this.propertiesModel.showTime * 1000);
        }
    }

    get propertiesModel(): RssItemProperties {
        return this.item.properties
            ? (this.item.properties as RssItemProperties)
            : ({} as RssItemProperties);
    }

    // computed
    get styleModel() {
        return this.item.css && Object.entries(this.item.css).length > 0 && this.item.css.constructor === Object ? this.item.css as RssCSS : this.itemStyle ? this.itemStyle.css as RssCSS : {} as RssCSS;
    }

    // methods
    setNextItem() {
        this.$emit("setNextItem", { error: false, id: this.item.id } as setNextItem);
    }
}
